import { ILeadRepository } from '../../ports/ILeadRepository';

export class ProcessLeadUseCase {
  constructor(private leadRepository: ILeadRepository) {}

  async execute(id: number, isTarget: boolean): Promise<void> {
    return this.leadRepository.process(id, isTarget);
  }
}